import React from 'react';
import {
  ProjectBoxOne
} from '../../components';

const ProjectThree = ({...restProps})=> {

  return (
    <div {...restProps}>
      <div className="container">        
        <div className="row">
          
          <div className="col-md-6 col-xxl-auto">
            <ProjectBoxOne
              image="images/project/eksu-min.png"
              title="Ekiti State University"
              tag="Web View"
              path="/project-details"
            />
          </div>
          <div className="col-md-6 col-xxl-auto">
            <ProjectBoxOne
              image="images/project/bouesti-min.jpg"
              title="BOUESTI"
              tag="Web View"
              path="/project-details"
            />
          </div>
          <div className="col-md-6 col-xxl-auto">
            <ProjectBoxOne
              image="images/project/cbt.jpg"
              title="BOUESTI"
              tag="CBT Software"
              path="/project-details"
            />
          </div>

         
          <div className="col-md-6 col-xxl-auto">
            <ProjectBoxOne
              image="images/project/eksuphone.jpg"
              title="Ekiti State University"
              tag="Mobile View"
              path="/project-details"
            />
          </div>
          <div className="col-md-6 col-xxl-auto">
            <ProjectBoxOne
              image="images/project/bouesti-phone2.jpg"
              title="BOUESTI"
              tag="Mobile View"
              path="/project-details"
            />
          </div>
          <div className="col-md-6 col-xxl-auto">
            <ProjectBoxOne
              image="images/project/voting.png"
              title="BOUESTI"
              tag="Voting Software"
              path="/project-details"
            />
          </div>
         
        </div>
      </div>
    </div>
  );
}

export default ProjectThree;